export const sections = [
    { key: 'listing', label: 'Listing Data' },
    { key: 'user', label: 'User Data' },
    { key: 'dateTime', label: 'General Date/Time' },
    { key: 'contentAutomation', label: 'Content Automation Settings (Global Admin Only)' },
    { key: 'altosData', label: 'Altos Data (Global Admin Only)' },
];